import { useSnackbar } from "notistack";
import { State } from "../../../domain/model/ResponseState";
import { useEffect } from "react";
import { GetAdminInfoUseCase } from "../../../domain/usecase/admin/getInfo/UseCase";

export function HomeViewModel(getAdminInfoUseCase: GetAdminInfoUseCase) {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    getAdminInfo();
  }, []);
  async function getAdminInfo() {
    const response = await getAdminInfoUseCase.invoke();
    switch (response.responseState) {
      case State.Success:
        if (!response.data) return;
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error",
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }
}
